module.exports = __webpack_public_path__ + "public/images/prizes-slider-arrow.bc9bd9ca1c8eac4f55f31a424e5df009.svg";